/**
 * Tela preta exibida fora da janela de operating hours (action = 'black_screen').
 * Tela completamente escura — sem nenhum elemento visual.
 */
import { useHeartbeat } from '@/hooks/use-heartbeat'

export function StandbyScreen() {
  // Mantém o device vivo enquanto a tela está preta. Sem isto, o heartbeat para
  // ao desmontar PlayerScreen e o player não recebe o sinal para voltar a tocar.
  useHeartbeat(null)

  return (
    <div
      style={{
        position: 'fixed',
        inset: 0,
        background: '#000'
      }}
    />
  )
}
